import React, { useState, useContext, useEffect } from 'react';
import { CardDate, CardTitle, CardContentContainer } from './elements';
import moment from 'moment';
import { Tag, BlogButton } from './elements';
import { View, Text, Pressable } from 'react-native';
import Modal from 'app/src/elements/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { elRed } from '../../styles/colors';
import EditBlog from './edit';
import { useNavigate } from 'react-router-dom';
import BlogContext from '../../contexts/BlogContext';
import AuthContext from '../../contexts/AuthContext';
import { useMutation } from '@apollo/client';
import { DESTROY_BLOG } from './queries';

const videoRegex = /video\//;

const Card = ({blog, refetch, fromShow}) => {
  const navigate = useNavigate();
  const { featuredLabel } = useContext(BlogContext);
  const { hasPolicy } = useContext(AuthContext);
  const [showEditModal, setShowEditModal] = useState();

  const [deleteBlog] = useMutation(DESTROY_BLOG, {
    onCompleted: (response) => {
      if(refetch) {
        refetch();
      }
    }
  });

  const getContent = (content) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Find all action-text-attachments and convert them to video elements
    const attachments = tempDiv.querySelectorAll('action-text-attachment');
    attachments.forEach((attachment) => {
      const type = attachment.getAttribute('content-type');
      const match = type.match(videoRegex);
      if (match) {
        const videoUrl = attachment.getAttribute('url');
        const videoElement = document.createElement('video');
        videoElement.setAttribute('controls', 'true');
        videoElement.setAttribute('style', 'max-width: 100%');

        const sourceElement = document.createElement('source');
        sourceElement.setAttribute('src', videoUrl);
        sourceElement.setAttribute('type', type); // Adjust based on your video type

        videoElement.appendChild(sourceElement);
        attachment.replaceWith(videoElement); // Replace the action-text-attachment with the video element
      }
    });

    return tempDiv.innerHTML; // Return modified HTML
  }

  const handleDelete = () => {
    if(window.confirm('Are you sure you want to delete this blog?')) {
      deleteBlog({ variables: { id: blog.id } })
    }
  }

  return (
    <>
      {hasPolicy({type: 'Blog', action: 'edit'}) ?
        <View style={{display: 'flex', flexDirection: 'row', marginTop: '20px'}}>
          <Pressable
            onPress={() => setShowEditModal(true)}
          >
            <Text style={{marginBottom: '5px'}}>
              <FontAwesomeIcon
                icon={faEdit} title="Edit Blog"
                size='xl'
                style={{color: elRed, marginRight: '5px'}}
              />
            </Text>
          </Pressable>
          <Pressable
            onPress={() => handleDelete()}
          >
            <Text style={{marginBottom: '5px', marginLeft: '20px'}}>
              <FontAwesomeIcon
                icon={faTrashAlt} title="Delete Blog"
                size='xl'
                style={{color: elRed, marginRight: '5px'}}
              />
            </Text>
          </Pressable>
        </View> :
        null
      }
      {blog.mainPhoto?.url ?
        <img src={blog.mainPhoto?.url}
          style={{
            width: '100%',
            maxHeight: '50vh',
            objectFit: 'contain'
          }}
        /> :
        null
      }
      {blog.mainVideo?.url ?
        <video controls src={blog.mainVideo?.url}
          style={{
            width: '100%',
            maxHeight: '50vh',
            objectFit: 'contain'
          }}
        /> :
        null
      }
      <View style={{display: 'flex', flexDirection: 'row'}}>
        {blog?.tags?.map(tag => {
          return (
            <Tag key={`tag-${tag.id}`}>{tag.name}</Tag>
          )
        })}
      </View>
      <CardTitle>{blog.title}</CardTitle>
      {/* <CardDate>{moment(blog.createdAt).format('MMMM Do YYYY')}</CardDate> */}
      <CardContentContainer fromShow={fromShow}>
        <div dangerouslySetInnerHTML={{ __html: getContent(blog.content) }} />
      </CardContentContainer>
      {!fromShow &&
        <Pressable onPress={() => navigate(`/blog/${blog.id}`)}>
          <BlogButton>Read More</BlogButton>
        </Pressable>
      }
      {showEditModal &&
        <Modal
          showModal
          setShowModal={setShowEditModal}
          modalType="Edit Blog"
        >
          <EditBlog
            blog={blog}
            setShowModal={setShowEditModal}
            refetch={refetch}
          />
        </Modal>
      }
    </>
  )
}

export default Card;